import { Suspense, lazy } from "react"
import { Navigate } from "react-router-dom"

import { isAiDiscoveryEnabled, isFeatureFlagMaybe } from "@/domain/user"
import { useFeatureFlags } from "@/hooks/useUser"
import { Loader } from "@/molecules/Loader"
import { HeaderPage } from "@/organisms/HeaderPage"
import { PageTemplate } from "@/templates/PageTemplate"

const AiDiscoveryContent = lazy(() =>
  import("./AiDiscoveryContent").catch(() => ({
    default: () => <Navigate to="/" replace />
  }))
)

export const AiDiscovery = () => {
  const aiDiscovery = useFeatureFlags("aiDiscovery")
  const isEnabled = isAiDiscoveryEnabled(aiDiscovery)
  const isLoading = isFeatureFlagMaybe(aiDiscovery)

  if (!isLoading && !isEnabled) return <Navigate to="/" replace />

  return (
    <PageTemplate
      full
      header={<HeaderPage titleTranslationKey="navigation.ai" />}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <Suspense fallback={<Loader />}>
          <AiDiscoveryContent />
        </Suspense>
      )}
    </PageTemplate>
  )
}
